module.exports = __webpack_public_path__ + "static/media/mccauley-date-o-connell-architects.b74c4c67.png";